import { SiteLink } from 'interfaces/site-link.interface';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

export const reportNoticeLink: SiteLink = {
    label: 'Zgloś kwestię prawną',
    href: '/report-notice/index.html',
    title: 'Zgloś kwestię prawną',
    rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER,
    icon: 'mail',
    weight: '600',
    target: LinkTarget.BLANK
};
